import type { FaireProductEntity } from "../../entity_types/product";

export const p_z6rzw4gab5: FaireProductEntity = {
  token: "p_z6rzw4gab5",
  type: "product",
  name: "Brown Bandana Fringe Cardigan",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/565d3844d83293b66b64daff9987b7f6fffebc7a1b633a608f1cb9f6b8d0108b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8afe5f9be2183f0a0f4a29a669918e2f570b7e520ae6553edde23830dc36ae61.jpeg",
    "https://cdn.faire.com/fastly/26e006be771834950a478e417471dade666a119d1c871a83d45763b0f33856cd.jpeg",
    "https://cdn.faire.com/fastly/09f511a11df44d767eebc2c72b3b0af7a39388f2405a02b90a30ad3196646223.jpeg",
    "https://cdn.faire.com/fastly/cf304e05f609e1a45e9c2afc8c5d76a1d8a1ed60f3f68986bcc2dbf18bbe047f.jpeg"
  ],
  priceDollars: 33.95,
  description: "Brown Bandana Fringe Cardigan featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, long sleeves, and fringe trim along the hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:58.457Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
